import NProgress from 'nprogress';
import axiosInstance from "../../../../axiosInstance";
import { HRMS_ATS_API_URL, HRMS_RESUME_PARSER_API } from "../../../Constants/baseConstant";
import { getDomain, getUserData } from '../../Base/helper/baseFunctions';

export const GetUserProfileScoreHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/ats/getUserProfileScore`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            workspace: params?.domain,
            ats_jobpost_id: params?.ats_jobpost_id || 0,
            page_number: params?.page_number || null,
            page_size: params?.page_size || null,
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const AddProfileScoreHelper = async (params) => {
    var user = getUserData();
    NProgress.start()
    return await axiosInstance(`/profilescore`, {
        method: "POST",
        baseURL: HRMS_RESUME_PARSER_API,
        data: {
            workspace_name: [user.domain],
            job_post_id: [params?.ats_jobpost_id || 0],
            user_id: [user.ats_user_id],
            candidate_id: params?.candidate_id
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data?.data?.result }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data ?? null }
        })
}
export const PythonScreeningScoreHelper = async (params) => {
    const user = getUserData();
    NProgress.start()
    return await axiosInstance(`/prescreenscore`, {
        method: "POST",
        baseURL: HRMS_RESUME_PARSER_API,
        data: {
            candidate_job_ids: params?.candidate_job_id,
            workspace_name: [getDomain()],
            user_id: [user.ats_user_id],
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data ?? null }
        })
}
// jd generation 
export const AIJobCreationHelper = async (params) => {
    const user = getUserData();
    NProgress.start()
    return await axiosInstance(`/jdgenerate`, {
        method: "POST",
        baseURL: HRMS_RESUME_PARSER_API,
        data: {
            workspace_name: [getDomain()],
            job_data: params?.job_data,
            user_id: [user?.ats_user_id],
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data ?? null }
        })
}
// resume pdf data to generate score 
export const ResumeCSVHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/resumecsvdata`, {
        method: "POST",
        baseURL: HRMS_RESUME_PARSER_API,
        data: {
            workspace_name: [getDomain()],
            files: params.files,
            candidate_id: params?.candidate_id
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data?.data?.result }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data ?? null }
        })
}